import React from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import { Field } from 'redux-form';
import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';
import cn from 'classname';

import CustomizableBlock from '../../../../../shared/customizable-block';
import InputField from '../../../../../shared/form-elements/input';
import CheckboxField from '../../../../../shared/form-elements/checkbox';
import SelectField from '../../../../../shared/form-elements/select/field';

const isRocket = process.env.CPA_ENV === 'rocket';

const DragHandle = SortableHandle(() => <div className="drag-handle" />);

const checkBoostValue = value => {
	if (value.length > 6) return value.slice(0, 6);
	return value.replace(/,/g, '.')
		.split('.')
		.map((elem) => elem.replace(/\D+/, ''))
		.slice(0, 2)
		.join('.');
};

const SortableItem = SortableElement(props => {
	const field = props.fields.get(props.originalIndex);
	const shouldDisableAffiliate =
		props.initialValues['targeting'] &&
		!!find(props.initialValues['targeting'], entity => entity['country_code'] === field['country_code']);

	const activeCheckboxState =
		field.location_id &&
		field.location_id[0] &&
		find(props.activeCheckboxStates, { locationId: field.location_id[0].value });

	const shouldDisablePayouts =
		activeCheckboxState && (activeCheckboxState.value === 'indeterminate' || activeCheckboxState.value === 'false');

	return (
		<tr key={props.originalIndex} className="targeting-row-drag">
			<td className="location">
				<div className="ui-form__element location__field">
					<DragHandle />
					<Field
						name={`${props.parentName}.location_id`}
						placeholder={props.intl('Select location')}
						component={SelectField}
						multi={false}
						showLabel={false}
						disabled={shouldDisableAffiliate}
						options={props.locationsLookups}
					/>
				</div>
			</td>

			<td className="price">
				<div className="ui-form__element">
					<Field
						name={`${props.parentName}.price`}
						placeholder=""
						showLabel={false}
						component={InputField} />
				</div>
			</td>
			<td className="price">
				<div className="ui-form__element">
					<Field
						name={`${props.parentName}.usd`}
						placeholder=""
						disabled={shouldDisablePayouts}
						showLabel={false}
						component={InputField}
					/>
				</div>
			</td>
			<CustomizableBlock
				className="percent"
				tag='td'
				settingId='offer-targeting-max-aff-payout'
				isHidden={!isRocket}
			>
				<div className="ui-form__element">
					<Field
						name={`${props.parentName}.competence_percent`}
						showLabel={false}
						component={InputField} />
				</div>
			</CustomizableBlock>
			<CustomizableBlock
				className="price" tag='td'
				settingId='offer-targeting-max-aff-payout'
				isHidden={!isRocket}
			>
				<div className="ui-form__element">
					<InputField
						showLabel={false}
						meta={{}}
						disabled
						input={{
							value: Math.round((100 + Number(field.competence_percent)) * Number(field.usd) / 100) || ''
						}}
					/>
				</div>
			</CustomizableBlock>
			<CustomizableBlock
				className="price" tag='td' settingId='offer-targeting-max-aff-payout'
				isHidden={isRocket}
			>
				<div className="ui-form__element">
					<Field
						name={`${props.parentName}.max_amount_usd`}
						placeholder=""
						showLabel={false}
						component={InputField} />
				</div>
			</CustomizableBlock>
			{!isRocket && (
				<td className="price last">
					<div className="ui-form__element">
						<Field
							name={`${props.parentName}.form_boost_value`}
							placeholder=""
							disabled={shouldDisablePayouts}
							showLabel={false}
							component={InputField}
							normalize={checkBoostValue}
						/>
					</div>
				</td>
			)}
			{!isRocket && (
				<IsActiveTD props={props} field={field} activeCheckboxState={activeCheckboxState} />
			)}
			{!isRocket && (
				<td className="checkbox-option__second">
					<div className="ui-form__element">
						<Field
							name={`${props.parentName}.is_own_callcenter`}
							normalize={v => !!v}
							component={CheckboxField}
						/>
					</div>
				</td>
			)}
			{!isRocket && (
				<td className="checkbox-option__third">
					<div className="ui-form__element">
						<Field
							name={`${props.parentName}.is_contest_enabled`}
							normalize={v => !!v}
							component={CheckboxField}
						/>
					</div>
				</td>
			)}
			{!isRocket && (
				<td className="checkbox-option__fourth">
					<div className="ui-form__element">
						<Field
							name={`${props.parentName}.is_booster_available`}
							format={v => (isUndefined(v) || !!v)}
							normalize={v => !!v}
							component={CheckboxField}
						/>
					</div>
				</td>
			)}
			<td className="points">
				<div className="ui-form__element">
					<Field
						name={`${props.parentName}.contest_points`}
						showLabel={false}
						component={InputField} />
				</div>
			</td>
			<td className="cap">
				<div className="ui-form__element">
					<Field
						name={`${props.parentName}.cap`}
						showLabel={false}
						component={InputField} />
				</div>
			</td>
			{isRocket && (
				<td className="empty" />
			)}
			{isRocket && (
				<IsActiveTD props={props} field={field} activeCheckboxState={activeCheckboxState} />
			)}
			<td className="action">
				{props.can('edit') && (
					<span
						className="delete"
						onClick={() => {
							if (confirm(props.intl('Delete targeting %s', '?'))) {
								field.location_id ? props.remove(field.location_id) : props.fields.remove(props.originalIndex);
							}
						}}
					/>
				)}
			</td>
		</tr>
	);
});

export default SortableItem;

const getActiveCheckboxValue = ({ value }) => (value === 'true' ? true : false);

function IsActiveTD({ props, field, activeCheckboxState }) {
	return (
		<td
			className={cn({
				'checkbox-option__first': true,
				'partially-active': activeCheckboxState && activeCheckboxState.value === 'indeterminate'
			})}
		>
			<div className="ui-form__element">
				<Field
					name={`${props.parentName}.is_active`}
					format={v => activeCheckboxState && getActiveCheckboxValue(activeCheckboxState)}
					normalize={v => !!v}
					component={CheckboxField}
					onChange={e => props.rotateActiveCheckbox(field)}
				/>
			</div>
			{activeCheckboxState &&
				activeCheckboxState.value === 'indeterminate' && (
				<div className="affiliates-popup">
					<div className="ui-form__element affiliates">
						<Field
							name={`${props.parentName}.affiliate_ids`}
							placeholder={props.intl('Affiliates')}
							component={SelectField}
							searchable={true}
							multi={true}
							options={props.affiliatesLookups}
						/>
					</div>
				</div>
			)}
		</td>
	);
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/targeting/sortable/item.js